type FormHoneypotFieldProps = {
	label: string;
};

export function FormHoneypotField({ label }: FormHoneypotFieldProps) {
	return (
		<div
			aria-hidden="true"
			style={{
				position: "absolute",
				left: "-9999px",
				width: "1px",
				height: "1px",
				overflow: "hidden",
			}}
		>
			<label htmlFor="additional_info">{label}</label>
			<input id="additional_info" name="additional_info" type="text" autoComplete="off" tabIndex={-1} defaultValue="" />
		</div>
	);
}
